export const queryParamState = {
    // @ts-ignore
    queryParam: {},
    _runtimeInfo: {}
};
export var QueryParamStateAction;
(function (QueryParamStateAction) {
    QueryParamStateAction["UpdateQueryParam"] = "UpdateQueryParam";
})(QueryParamStateAction || (QueryParamStateAction = {}));
// @ts-ignore
export function queryParamReducer(state = queryParamState, action) {
    switch (action.type) {
        case QueryParamStateAction.UpdateQueryParam:
            {
                const newState = Object.assign(Object.assign({}, state), { queryParam: action.data });
                return newState;
            }
        default:
            return state;
    }
}
